import { GridCol, mixins, styled } from '@bob/library'

const Base = styled(GridCol)`
  display: flex;
  flex-wrap: wrap;
  ${mixins.media.min.desktop} {
    justify-content: space-between;
    flex-wrap: nowrap;
  }
`

export const Wrapper = styled(Base)`
  align-items: center;
`

export const ContentWrapper = styled(Base)`
  flex-wrap: wrap-reverse;
`

export const Content = styled(GridCol)``

export const HeaderContent = styled(GridCol)`
  @media print {
    width: 65%;
  }
`

export const SideBar = styled(GridCol)`
  position: relative;
`

export const HeaderSide = styled(GridCol)`
  @media print {
    width: 30%;
    margin-top: 50px;
    max-width: 350px;
  }
`
